/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";

/**
 *
 * @export
 * @interface LogUpdateRequest
 */
export interface LogUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof LogUpdateRequest
   */
  groupId?: string;
  /**
   *
   * @type {string}
   * @memberof LogUpdateRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof LogUpdateRequest
   */
  note?: string;
  /**
   *
   * @type {number}
   * @memberof LogUpdateRequest
   */
  startTime?: number;
  /**
   *
   * @type {number}
   * @memberof LogUpdateRequest
   */
  endTime?: number;
  /**
   *
   * @type {number}
   * @memberof LogUpdateRequest
   */
  recordSize?: number;
  /**
   *
   * @type {number}
   * @memberof LogUpdateRequest
   */
  recordCount?: number;
  /**
   *
   * @type {object}
   * @memberof LogUpdateRequest
   */
  context?: object;
  /**
   *
   * @type {boolean}
   * @memberof LogUpdateRequest
   */
  locked?: boolean;
  /**
   *
   * @type {Date}
   * @memberof LogUpdateRequest
   */
  deletedAt?: Date;
}

export function LogUpdateRequestFromJSON(json: any): LogUpdateRequest {
  return LogUpdateRequestFromJSONTyped(json, false);
}

export function LogUpdateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LogUpdateRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    groupId: !exists(json, "group_id") ? undefined : json["group_id"],
    name: !exists(json, "name") ? undefined : json["name"],
    note: !exists(json, "note") ? undefined : json["note"],
    startTime: !exists(json, "start_time") ? undefined : json["start_time"],
    endTime: !exists(json, "end_time") ? undefined : json["end_time"],
    recordSize: !exists(json, "record_size") ? undefined : json["record_size"],
    recordCount: !exists(json, "record_count")
      ? undefined
      : json["record_count"],
    context: !exists(json, "context") ? undefined : json["context"],
    locked: !exists(json, "locked") ? undefined : json["locked"],
    deletedAt: !exists(json, "deleted_at")
      ? undefined
      : new Date(json["deleted_at"]),
  };
}

export function LogUpdateRequestToJSON(value?: LogUpdateRequest | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    group_id: value.groupId,
    name: value.name,
    note: value.note,
    start_time: value.startTime,
    end_time: value.endTime,
    record_size: value.recordSize,
    record_count: value.recordCount,
    context: value.context,
    locked: value.locked,
    deleted_at:
      value.deletedAt === undefined ? undefined : value.deletedAt.toISOString(),
  };
}
